import React, { useContext, useEffect, useState, useRef } from "react";
import {
  TextField,
  Box,
  Button,
  Grid,
  InputAdornment,
  Typography,
  CircularProgress,
  MenuItem,
  Popover,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "components/structure/Layout";
import SurveyTable from "./SurveyTable";
import { SnackbarContext } from "context/snackBarContext";
import CustomPagination from "../Import/Common/CustomPagination";
import CommonService from "services/CommonService";
import HierarchyDropdown from "../ManageUnannouncedVisitor/HierarchyDropdown";
import SurveyManagementService from "services/SurveyManagementService";
import { useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import ReopenModal from "./ReopenModal";
import ApproveModal from "./ApproveModal";
import { useTranslation } from "react-i18next"; // Add this import
import ViewSurvey from "./ViewSurvey"; // Add this import
import SignaturePage from "./SignaturePage"; // Add this import
import dayjs from "dayjs";
let setStaticSelectedCountryCode = [];

const SurveyReopen = () => {
  const { t } = useTranslation(); // Add this hook
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [surveyData, setSurveyData] = useState([]);
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
  const [cropYears, setCropYears] = useState([]);
  const [selectedCropYear, setSelectedCropYear] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(5);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [assignedFilter, setAssignedFilter] = useState("all");
  const [hierarchyData, setHierarchyData] = useState([]);
  const [selectedHierarchy, setSelectedHierarchy] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);
  // const { user } = AuthData();
  const user = JSON.parse(sessionStorage.getItem("BAT_USER"));
  const [countries, setCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState();
  const [statusPickList, setStatusPickList] = useState([]);
  const [selectedStatusPickList, setSelectedStatusPickList] = useState([]);
  const [cropStages, setCropStages] = useState([]);
  const [selectedCropStage, setSelectedCropStage] = useState("");
  const [surveyStartDate, setSurveyStartDate] = useState(null);
  const [surveyEndDate, setSurveyEndDate] = useState(null);
  const [selectedForReopen, setSelectedForReopen] = useState(new Set());
  const [selectedForApprove, setSelectedForApprove] = useState(new Set());
  const [isApprover, setIsApprover] = useState(false);
  const [isGlobalProfile, setIsGlobalProfile] = useState(
    user?.profileAttribute == "Global" ? true : false
  );
  const [reopenModalOpen, setReopenModalOpen] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [isVisitCompliance, setIsVisitCompliance] = useState(false);
  const [currentView, setCurrentView] = useState("main"); // 'main', 'view', 'signature'
  const [selectedSurveyData, setSelectedSurveyData] = useState(null);
  const [bulkActions, setBulkActions] = useState({
    bulkReopen: false,
    bulkApprove: false,
  });
  const operationalLevelRef = useRef(null);
  const [popoverWidth, setPopoverWidth] = useState(0);
  const [observer, setObserver] = useState(null);
  const cropStageRef = useRef(null);
  const [cropStageDropdownWidth, setCropStageDropdownWidth] = useState(null);

  useEffect(() => {
    if (cropStageRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          setCropStageDropdownWidth(entry.target.offsetWidth);
        }
      });
      resizeObserver.observe(cropStageRef.current);
      return () => resizeObserver.disconnect();
    }
  }, []);

  useEffect(() => {
    fetchCountries();
    fetchIsApprover();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      fetchSurveyData(currentPage, itemsPerPage);
      fetchHierarchyData();
      getCropYear();
      getCropStage();
      getStatusPickList();
    }, 1000);
  }, [selectedCountries]);

  const fetchIsApprover = async () => {
    try {
      const response = await SurveyManagementService.getIsApprover({
        headers: { apiCountryCode: selectedCountryCode },
      });
      if (response?.data?.response) {
        setIsApprover(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching isApprover data:", error);
    }
  };
  const fetchCountries = () => {
    CommonService?.fetchCountries()
      .then((res) => {
        let countries = res?.data?.response;
        setCountries(countries);
        const kenCountry = countries.find(
          (country) => country.countryCode === "HRV"
        );
        if (kenCountry) {
          setStaticSelectedCountryCode = kenCountry;
          setSelectedCountries(kenCountry);
          setSelectedCountryCode(kenCountry?.countryCode);
          //   setSelectedCountries(kenCountry?.countryName);
          //   setSelectedCountryCode(kenCountry?.countryCode);
        } else {
          setSelectedCountries(countries[0]);
          setSelectedCountryCode(kenCountry[0]?.countryCode);
        }
      })
      .catch((ex) => {
        setCountries([]);
        console.log("error", ex);
      });
  };
  const fetchHierarchyData = async () => {
    try {
      let headers = getXTenantIDHeader();
      if (headers?.apiCountryCode == "") return;
      const response = await SurveyManagementService.getHierarchyDropdown(
        { isMuv: false },
        {
          headers,
        }
      );
      if (response?.data?.response) {
        const hierarchyData = response.data.response;
        setHierarchyData(hierarchyData);
        // Get all location codes and IDs
        const { allIds, allLocations } = getAllNodesData(hierarchyData);
        setSelectedHierarchy(allIds);
        setSelectedLocations(allLocations);
      }
    } catch (error) {
      setSelectedHierarchy([]);
      setSelectedLocations([]);
      setHierarchyData([]);
      console.error("Error fetching hierarchy data:", error);
    }
  };
  const getCropYear = () => {
    let headers = getXTenantIDHeader();
    if (headers?.apiCountryCode === "") return;

    SurveyManagementService?.getCropYear({ headers })
      .then((res) => {
        const cropYearData = res?.data?.response || [];
        setCropYears(cropYearData);

        // Find and set the current crop year
        const currentCropYear = cropYearData.find(
          (year) => year.isCurrentCropYear === true
        );
        if (currentCropYear) {
          setSelectedCropYear(currentCropYear.cropYear);
        }
      })
      .catch((error) => {
        setCropYears([]);
        console.error("Error fetching crop years:", error);
      });
  };

  useEffect(() => {
    if (selectedCropYear) {
      fetchSurveyData(currentPage, itemsPerPage);
    }
  }, [selectedCropYear]);

  // Update the crop year change handler
  const handleCropYearChange = (e) => {
    setSelectedCropYear(e.target.value);
    clearSelections();
    setCurrentPage(0); // Reset page
  };

  const getCropStage = () => {
    let headers = getXTenantIDHeader();
    if (headers?.apiCountryCode === "") return;

    SurveyManagementService?.getCropStage({ headers })
      .then((res) => {
        const stages = res?.data?.response || [];
        setCropStages(stages);

        // Find and set Post Contract as default
        const postContract = stages.find(
          (stage) => stage.cropStageName === "Post Contract"
        );
        if (postContract) {
          setSelectedCropStage(postContract.cropStageUid);
        }
      })
      .catch((error) => {
        setCropStages([]);
        setSelectedCropStage([]);
        console.error("Error fetching crop stages:", error);
      });
  };

  useEffect(() => {
    if (selectedCropStage) {
      fetchSurveyData(currentPage, itemsPerPage);
    }
  }, [selectedCropStage]);

  const handleCropStageChange = (e) => {
    const selectedStage = cropStages.find(
      (stage) => stage.cropStageUid === e.target.value
    );
    setSelectedCropStage(e.target.value);
    setIsVisitCompliance(selectedStage?.visitCompliance || false);
    clearSelections();
    setCurrentPage(0); // Reset page
  };

  const getStatusPickList = () => {
    let headers = getXTenantIDHeader();

    SurveyManagementService.fetchPickListSurvey(
      { pickListCodes: ["CSSSTAT"] },
      { headers: headers }
    )
      .then((res) => {
        let data = res?.data?.response?.CSSSTAT;
        setStatusPickList(data);
        // Set all statuses selected by default
        setSelectedStatusPickList(data);
      })
      .catch((ex) => {
        setStatusPickList([]);
        setSelectedStatusPickList([]);
        console.log("error", ex);
      });
  };
  const getXTenantIDHeader = () => {
    const headers = {};
    let selectedCountryCode = "";
    if (user?.profileAttribute == "Global") {
      selectedCountryCode = setStaticSelectedCountryCode?.countryCode;
      //   const kenCountry = countries.find(
      //     (country) => country.countryName == selectedCountries
      //   );
      //   selectedCountryCode = kenCountry?.countryCode;
    }
    if (user?.profileAttribute == "Local") {
      selectedCountryCode = user?.countryCode;
    }
    // alert(selectedCountryCode)
    headers["apiCountryCode"] = selectedCountryCode;
    return headers;
  };

  // Add date change handlers
  const handleStartDateChange = (newValue) => {
    // Don't allow start date to be after end date
    if (surveyEndDate && newValue > surveyEndDate) {
      setSeverity("error");
      setMessage(t("surveyReopen.errors.startDateAfterEnd"));
      setOpenAlert(true);
      return;
    }
    setSurveyStartDate(newValue);
    clearSelections();
    setCurrentPage(0); // Reset page
  };
  useEffect(() => {
    if (surveyStartDate) {
    }
    fetchSurveyData(currentPage, itemsPerPage);
  }, [surveyStartDate]);

  const handleEndDateChange = (newValue) => {
    // Don't allow end date to be before start date
    if (surveyStartDate && newValue < surveyStartDate) {
      setSeverity("error");
      setMessage(t("surveyReopen.errors.endDateBeforeStart"));
      setOpenAlert(true);
      return;
    }
    setSurveyEndDate(newValue);
    clearSelections();
    setCurrentPage(0); // Reset page
  };
  useEffect(() => {
    if (surveyEndDate) {
    }
    fetchSurveyData(currentPage, itemsPerPage);
  }, [surveyEndDate]);
  // Update the fetchSurveyData function
  const fetchSurveyData = async (pageNumber, pageSize) => {
    if (selectedCropStage == "") return;
    const params = {
      pageNumber: pageNumber,
      size: pageSize,
      cropYear: selectedCropYear || 2024,
      locationCodes: [...selectedLocations],
      cropStageId: selectedCropStage,
      isVisitCompliance:
        cropStages.find((stage) => stage.cropStageUid === selectedCropStage)
          ?.visitCompliance || false,
      status: selectedStatusPickList.map((status) => status.pickListItemCode),
      // Add date parameters if they exist
      ...(surveyStartDate && {
        fromDate: surveyStartDate.format("YYYY-MM-DD"),
      }),
      ...(surveyEndDate && { toDate: surveyEndDate.format("YYYY-MM-DD") }),
    };
    if (!searchKeyword == "") {
      params.keyword = searchKeyword;
    }

    let headers = getXTenantIDHeader();
    if (headers?.apiCountryCode == "") return;

    try {
      setLoading(true);
      const response = await SurveyManagementService?.getSurveyApproverData(
        params,
        { headers }
      );
      setLoading(false);

      // Preserve selections when updating survey data
      const newSurveyData = response?.data?.response?.surveyData.map(
        (item) => ({
          ...item,
          isReopen: selectedForReopen.has(item.headerId),
          isApproved: selectedForApprove.has(item.headerId),
        })
      );
      setSurveyData(newSurveyData);
      setTotalItems(response?.data?.response?.totalItems);
      setCurrentPage(pageNumber);
    } catch (error) {
      setLoading(false);
      setSurveyData([]);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
    }
  };

  // Modify getAllNodesData function to get all nodes and their children
  const getAllNodesData = (data) => {
    const allIds = [];
    const allLocations = new Set();

    const traverse = (items) => {
      items.forEach((item) => {
        allIds.push(item.ihId);
        allLocations.add(item.ihLocationCode);

        if (item.childHierarchy) {
          traverse(item.childHierarchy);
        }
      });
    };

    traverse(data);
    return {
      allIds,
      allLocations: Array.from(allLocations),
    };
  };
  // Update the status change handler
  const handleStatusChange = (event) => {
    const selectedValue = event.target.value;

    // Handle "Select All" option
    if (selectedValue.includes("all")) {
      setSelectedStatusPickList(
        selectedStatusPickList.length === statusPickList.length
          ? []
          : [...statusPickList]
      );
    } else {
      setSelectedStatusPickList(selectedValue);
    }
    clearSelections();
    setCurrentPage(0); // Reset page
    // fetchSurveyData(currentPage, itemsPerPage);
  };
  useEffect(() => {
    fetchSurveyData(currentPage, itemsPerPage);
  }, [selectedStatusPickList]);
  // Update the assignment update handler

  const handleAssignmentUpdate = (updatedItem, type) => {
    // Check if the item is already selected for reopen or approve
    const isCurrentlyReopen = Boolean(
      surveyData.find(
        (item) => item.headerId === updatedItem.headerId && item.isReopen
      )
    );
    const isCurrentlyApprove = Boolean(
      surveyData.find(
        (item) => item.headerId === updatedItem.headerId && item.isApproved
      )
    );

    // Toggle the selection based on which radio was clicked and current state
    const newItem = {
      ...updatedItem,
      isReopen: updatedItem.isReopen
        ? type == "bulk"
          ? updatedItem?.isReopen
          : !isCurrentlyReopen
        : false,
      isApproved: updatedItem.isApproved
        ? type == "bulk"
          ? updatedItem.isApproved
          : !isCurrentlyApprove
        : false,
    };

    // Update the survey data
    setSurveyData((prevData) =>
      prevData.map((item) =>
        item.headerId === newItem.headerId ? newItem : item
      )
    );

    // Update the selected sets
    if (newItem.isReopen) {
      setSelectedForReopen((prev) => {
        const newSet = new Set(prev);
        newSet.add(newItem.headerId);
        return newSet;
      });
      setSelectedForApprove((prev) => {
        const newSet = new Set(prev);
        newSet.delete(newItem.headerId);
        return newSet;
      });
    } else if (newItem.isApproved) {
      setSelectedForApprove((prev) => {
        const newSet = new Set(prev);
        newSet.add(newItem.headerId);
        return newSet;
      });
      setSelectedForReopen((prev) => {
        const newSet = new Set(prev);
        newSet.delete(newItem.headerId);
        return newSet;
      });
    } else {
      // If neither is selected, remove from both sets
      setSelectedForReopen((prev) => {
        const newSet = new Set(prev);
        newSet.delete(newItem.headerId);
        return newSet;
      });
      setSelectedForApprove((prev) => {
        const newSet = new Set(prev);
        newSet.delete(newItem.headerId);
        return newSet;
      });
    }
  };

  const handleReopenSubmit = () => {
    if (selectedForReopen.size === 0) return;
    setReopenModalOpen(true);
  };

  const handleReopenConfirm = async (comment) => {
    try {
      setLoading(true);
      const selectedIds = Array.from(selectedForReopen);
      const today = dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const selectedHeaderIds = selectedIds
        .map((headerId) => {
          const survey = surveyData.find((item) => item.headerId === headerId);
          return survey?.headerId || "";
        })
        .filter(Boolean);
      // Get all completed survey IDs
      const completedSurveyIds = surveyData
        .filter((item) => item?.status?.toLowerCase() === "completed")
        .map((item) => item.headerId);

      // Get IDs that were not selected for reopening
      const notSelectedIds = completedSurveyIds.filter(
        (id) => !selectedIds.includes(id)
      );

      const params = {
        locationCodes: [...selectedLocations],
        statusToUpdate: "Re-Opened",
        notInHeaderIds: bulkActions.bulkReopen ? notSelectedIds : [],
        reopenComment: comment,
        actionDate: today,
        // approverName: user?.userName,
        cropYear: selectedCropYear,
        cropStageId: selectedCropStage,
        isVisitCompliance:
          cropStages.find((stage) => stage.cropStageUid === selectedCropStage)
            ?.visitCompliance || false,
        status: selectedStatusPickList.map((status) => status.pickListItemCode),
        ...(surveyStartDate && {
          fromDate: surveyStartDate.format("YYYY-MM-DD"),
        }),
        ...(surveyEndDate && { toDate: surveyEndDate.format("YYYY-MM-DD") }),
      };
      if (!bulkActions.bulkReopen) {
        params.headerIds = selectedHeaderIds;
      }

      await SurveyManagementService.reopenSurveys(params, {
        headers: getXTenantIDHeader(),
      });

      // Only clear the reopen selections, keep approve selections
      setSelectedForReopen(new Set());
      await fetchSurveyData(currentPage, itemsPerPage);

      setSeverity("success");
      setMessage("Surveys reopened successfully");
      setOpenAlert(true);
    } catch (error) {
      setSeverity("error");
      setMessage(error?.response?.data?.message || "Failed to reopen surveys");
      setOpenAlert(true);
    } finally {
      setLoading(false);
      setReopenModalOpen(false);
    }
  };

  const handleApproveSubmit = () => {
    if (selectedForApprove.size === 0) return;
    setApproveModalOpen(true);
  };

  const handleApproveConfirm = async (comment) => {
    try {
      setLoading(true);
      const selectedIds = Array.from(selectedForApprove);
      const today = dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const selectedHeaderIds = selectedIds
        .map((headerId) => {
          const survey = surveyData.find((item) => item.headerId === headerId);
          return survey?.headerId || "";
        })
        .filter(Boolean);
      // Get all completed survey IDs
      const completedSurveyIds = surveyData
        .filter((item) => item?.status?.toLowerCase() === "completed")
        .map((item) => item.headerId);

      // Get IDs that were not selected for reopening
      const notSelectedIds = completedSurveyIds.filter(
        (id) => !selectedIds.includes(id)
      );

      const params = {
        locationCodes: [...selectedLocations],
        statusToUpdate: "Approved",
        notInHeaderIds: bulkActions.bulkApprove ? notSelectedIds : [],
        actionDate: today,
        approverName: user?.userName,
        cropYear: selectedCropYear,
        cropStageId: selectedCropStage,
        isVisitCompliance:
          cropStages.find((stage) => stage.cropStageUid === selectedCropStage)
            ?.visitCompliance || false,
        status: selectedStatusPickList.map((status) => status.pickListItemCode),
        ...(surveyStartDate && {
          fromDate: surveyStartDate.format("YYYY-MM-DD"),
        }),
        ...(surveyEndDate && { toDate: surveyEndDate.format("YYYY-MM-DD") }),
      };
      if (!bulkActions.bulkApprove) {
        params.headerIds = selectedHeaderIds;
      }
      await SurveyManagementService.reopenSurveys(params, {
        headers: getXTenantIDHeader(),
      });

      // Only clear the approve selections, keep reopen selections
      setSelectedForApprove(new Set());
      await fetchSurveyData(currentPage, itemsPerPage);

      setSeverity("success");
      setMessage("Surveys approved successfully");
      setOpenAlert(true);
    } catch (error) {
      setSeverity("error");
      setMessage(error?.response?.data?.message || "Failed to approve surveys");
      setOpenAlert(true);
    } finally {
      setLoading(false);
      setApproveModalOpen(false);
    }
  };

  const paginate = (pageNumber, pageSize) => {
    setSelectedForReopen(new Set([]));
    setSelectedForApprove(new Set([]));
    fetchSurveyData(pageNumber - 1, pageSize);
  };
  const handleOperationalLevelClick = (event) => {
    if (operationalLevelRef.current) {
      const width = operationalLevelRef.current.offsetWidth;
      setPopoverWidth(width);
    }
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    if (operationalLevelRef.current) {
      // Create new ResizeObserver
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          setPopoverWidth(entry.target.offsetWidth);
        }
      });

      // Start observing the TextField
      resizeObserver.observe(operationalLevelRef.current);
      setObserver(resizeObserver);

      // Cleanup
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);

  const handleOperationalLevelClose = () => {
    setAnchorEl(null);
  };
  const handleHierarchySelect = (selectionData) => {
    const { selectedIds } = selectionData;
    setSelectedHierarchy(selectedIds);
    clearSelections();
    setCurrentPage(0); // Reset page

    // Get filtered location codes
    const filteredLocations = getFilteredLocationCodes(
      hierarchyData,
      selectedIds
    );
    setSelectedLocations(filteredLocations);
  };
  // Modify getFilteredLocationCodes function to get only selected nodes' location codes
  const getFilteredLocationCodes = (data, selectedIds) => {
    const locationCodes = new Set();

    const traverse = (items) => {
      items.forEach((item) => {
        // Only add location code if the current item's ID is directly selected
        if (selectedIds.includes(item.ihId)) {
          locationCodes.add(item.ihLocationCode);
        }

        // Continue traversing child hierarchies
        if (item.childHierarchy) {
          traverse(item.childHierarchy);
        }
      });
    };

    traverse(data);
    return Array.from(locationCodes);
  };

  useEffect(() => {
    if (hierarchyData == "" || hierarchyData?.length == 0) return;
    fetchSurveyData(currentPage, itemsPerPage);
  }, [selectedLocations]);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (selectedCropYear) {
        setCurrentPage(0); // Reset page
        fetchSurveyData(0, itemsPerPage); // Use page 0 instead of currentPage
      }
    }, 500); // 500ms delay

    return () => clearTimeout(timeoutId);
  }, [searchKeyword]);

  // Add this function to clear selections
  const clearSelections = () => {
    setSelectedForReopen(new Set());
    setSelectedForApprove(new Set());
  };

  // Update the filter change handlers to clear selections

  // For Countries
  const handleCountryChange = (e) => {
    const code = countries.find(
      (country) => country.countryCode === e.target.value
    );
    setStaticSelectedCountryCode = code;
    setSelectedCountries(code);
    clearSelections();
  };

  const handleViewSurvey = (surveyData) => {
    setSelectedSurveyData(surveyData);
    setCurrentView("view");
  };

  const handleShowSignature = () => {
    setCurrentView("signature");
  };

  const handleBack = () => {
    setCurrentView("main");
    setSelectedSurveyData(null);
  };

  const handleBulkActionChange = ({ bulkReopen, bulkApprove }) => {
    setBulkActions({ bulkReopen, bulkApprove });
  };

  return (
    <Layout title={t("surveyReopen.title")}>
      {currentView === "main" && (
        // Your existing SurveyReopen content
        <Box
          className="survey-container"
          sx={{ position: "relative", minHeight: "100vh" }}
        >
          <Typography
            sx={{
              color: "#102A62", // Primary Blue color
              fontFamily: "Montserrat",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "30px",
              letterSpacing: 0,
              marginBottom: 2, // Optional: adds some spacing below the title
            }}
          >
            {t("surveyReopen.title")}
          </Typography>

          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
              marginTop: 1,
              marginLeft: 0.1,
              paddingTop: 3,
              paddingRight: 3,
              paddingBottom: 3,
              backgroundColor: "#EFEFEF",
            }}
          >
            {isGlobalProfile && (
              <Grid item xs={12} sm={1.7}>
                <TextField
                  fullWidth
                  select
                  label={t("surveyReopen.filters.countries")}
                  variant="outlined"
                  value={selectedCountries?.countryCode || ""}
                  onChange={handleCountryChange}
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      color: "#00000099",
                      fontFamily: "Montserrat",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "20px",
                      letterSpacing: "0%",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "46px",
                      borderRadius: "5px",
                      "& fieldset": {
                        borderColor: "#C4C4C4",
                        borderRadius: "5px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#C4C4C4",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#C4C4C4",
                      },
                    },
                  }}
                >
                  {countries?.map((c) => (
                    <MenuItem key={c.countryName} value={c.countryCode}>
                      {c.countryName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            <Grid item xs={12} sm={1.7}>
              <TextField
                ref={operationalLevelRef}
                fullWidth
                label={t("surveyReopen.filters.operationalLevel")}
                variant="outlined"
                onClick={handleOperationalLevelClick}
                value={`${selectedHierarchy.length} ${t(
                  "surveyReopen.filters.selected"
                )}`}
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                    cursor: "pointer",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    "& input": {
                      height: "46px",
                      padding: "0 14px",
                      boxSizing: "border-box",
                    },
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              />
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleOperationalLevelClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                PaperProps={{
                  sx: {
                    height: "auto",
                    width: popoverWidth || "auto", // Use stored width directly
                    maxHeight: 273,
                    overflow: "auto",
                  },
                }}
              >
                <div
                  style={{
                    width: "100%",
                    maxHeight: 273,
                  }}
                >
                  <HierarchyDropdown
                    hierarchyData={hierarchyData}
                    selectedItems={selectedHierarchy}
                    onSelectionChange={handleHierarchySelect}
                  />
                </div>
              </Popover>
            </Grid>
            <Grid item xs={12} sm={1.7}>
              <TextField
                fullWidth
                select
                label={t("surveyReopen.filters.cropYear")}
                variant="outlined"
                value={selectedCropYear || ""}
                onChange={handleCropYearChange}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              >
                {cropYears.map((yearData) => (
                  <MenuItem
                    key={yearData.cropYearUid}
                    value={yearData.cropYear}
                  >
                    {yearData.cropYearName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={1.7}>
              <TextField
                ref={cropStageRef}
                fullWidth
                select
                label={t("surveyReopen.filters.cropStage")}
                variant="outlined"
                value={selectedCropStage}
                onChange={handleCropStageChange}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        width: cropStageDropdownWidth || "auto",
                        maxHeight: 273,
                      },
                    },
                  },
                }}
              >
                {cropStages.map((stage) => (
                  <MenuItem key={stage.cropStageUid} value={stage.cropStageUid}
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100%", // ensure it respects dropdown width
                    display: "block", // fix for inline display quirks
                    fontFamily: "Montserrat",
                  }}>
                    {stage.cropStageName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={1.7}>
              <TextField
                fullWidth
                select
                label={t("surveyReopen.filters.status")}
                variant="outlined"
                value={selectedStatusPickList || []} // Ensure it's always an array
                onChange={handleStatusChange}
                SelectProps={{
                  multiple: true,
                  renderValue: (selected) =>
                    selected
                      .map((status) => status.pickListDescription)
                      .join(", "),
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        overflowY: "auto",
                      },
                    },
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              >
                <MenuItem value="all">
                  <ListItemIcon>
                    <Checkbox
                      checked={
                        selectedStatusPickList?.length ===
                        statusPickList?.length
                      }
                      indeterminate={
                        selectedStatusPickList?.length > 0 &&
                        selectedStatusPickList?.length < statusPickList?.length
                      }
                      icon={<img src={CheckboxUntick} alt="Unchecked" />}
                      checkedIcon={<img src={CheckboxTick} alt="Checked" />}
                    />
                  </ListItemIcon>
                  <ListItemText primary={t("surveyReopen.filters.selectAll")} />
                </MenuItem>
                {statusPickList?.map((data) => (
                  <MenuItem key={data?.pickListItemCode} value={data}>
                    <ListItemIcon>
                      <Checkbox
                        checked={selectedStatusPickList.some(
                          (item) =>
                            item.pickListItemCode === data.pickListItemCode
                        )}
                        icon={<img src={CheckboxUntick} alt="Unchecked" />}
                        checkedIcon={<img src={CheckboxTick} alt="Checked" />}
                      />
                    </ListItemIcon>
                    <ListItemText primary={data.pickListDescription} />
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={1.7}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={t("surveyReopen.filters.surveyStartDate")}
                  value={surveyStartDate}
                  onChange={handleStartDateChange}
                  maxDate={surveyEndDate} // Limit start date
                  format="DD-MM-YYYY"  // Add this line to format the date
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      height: "46px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      "& input": {
                        cursor: "pointer",
                        pointerEvents: "none", // This prevents the input from capturing clicks
                      },
                      "& fieldset": {
                        borderColor: "#C4C4C4",
                        borderRadius: "5px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#C4C4C4",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#C4C4C4",
                      },
                    },
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      onClick: (e) =>
                        e.currentTarget.querySelector("button").click(), // This triggers the calendar
                      InputLabelProps: {
                        shrink: true,
                        sx: {
                          color: "#00000099",
                          fontFamily: "Montserrat",
                          fontWeight: 500,
                          fontSize: "18px",
                          lineHeight: "20px",
                          letterSpacing: "0%",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={1.7}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={t("surveyReopen.filters.surveyEndDate")}
                  value={surveyEndDate}
                  onChange={handleEndDateChange}
                  minDate={surveyStartDate} // Limit end date
                  format="DD-MM-YYYY"  // Add this line to format the date
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      height: "46px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      "& input": {
                        cursor: "pointer",
                        pointerEvents: "none", // This prevents the input from capturing clicks
                      },
                      "& fieldset": {
                        borderColor: "#C4C4C4",
                        borderRadius: "5px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#C4C4C4",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#C4C4C4",
                      },
                    },
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      onClick: (e) =>
                        e.currentTarget.querySelector("button").click(), // This triggers the calendar
                      InputLabelProps: {
                        shrink: true,
                        sx: {
                          color: "#00000099",
                          fontFamily: "Montserrat",
                          fontWeight: 500,
                          fontSize: "18px",
                          lineHeight: "20px",
                          letterSpacing: "0%",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{
              marginLeft: 0,
              paddingBottom: 2,
              paddingRight: 3,
              width: "100%",
              backgroundColor: "#EFEFEF",
            }}
          >
            <Grid item xs={12} sm={9}>
              <TextField
                fullWidth
                label={t("surveyReopen.filters.search")}
                variant="outlined"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)} // Add this line
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#00000099" }} />
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: "#00000099",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "46px",
                    borderRadius: "5px",
                    "& input": {
                      height: "46px",
                      padding: "0 14px",
                      boxSizing: "border-box",
                    },
                    "& fieldset": {
                      borderColor: "#C4C4C4",
                      borderRadius: "5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#C4C4C4",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#C4C4C4",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={1.5}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleReopenSubmit}
                disabled={selectedForReopen.size === 0}
                sx={{
                  backgroundColor: "#FF0400",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#FF0400",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#FFB4B4",
                  },
                  boxShadow: "none",
                  height: "46px",
                  border: "1px solid #C4C4C4",
                }}
              >
                {t("surveyReopen.buttons.reopen")}
              </Button>
            </Grid>
            <Grid item xs={12} sm={1.5}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleApproveSubmit}
                disabled={selectedForApprove.size === 0}
                sx={{
                  backgroundColor: "#50AF47",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#50AF47",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#A8D5A5",
                  },
                  boxShadow: "none",
                  height: "46px",
                  border: "1px solid #C4C4C4",
                }}
              >
                {t("surveyReopen.buttons.approve")}
              </Button>
            </Grid>
          </Grid>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              <SurveyTable
                data={surveyData}
                isApprover={isApprover}
                cropYear={selectedCropYear}
                onAssignmentUpdate={handleAssignmentUpdate}
                selectedStatusPickList={selectedStatusPickList}
                isGlobalProfile={isGlobalProfile}
                selectedForReopen={selectedForReopen}
                selectedForApprove={selectedForApprove}
                isVisitCompliance={isVisitCompliance} // Add this prop
                selectedCountry={getXTenantIDHeader()}
                onViewSurvey={handleViewSurvey} // Add this prop
                onBulkActionChange={handleBulkActionChange}
              />
              {surveyData.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    bottom: "-70px", // Changed from 70px to 0
                  }}
                >
                  <CustomPagination
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={(v) => setItemsPerPage(v)}
                    totalItems={totalItems}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                </div>
              )}
            </>
          )}
          <ReopenModal
            open={reopenModalOpen}
            onClose={() => setReopenModalOpen(false)}
            onConfirm={handleReopenConfirm}
            loading={loading}
          />
          <ApproveModal
            open={approveModalOpen}
            onClose={() => setApproveModalOpen(false)}
            onConfirm={handleApproveConfirm}
            loading={loading}
          />
        </Box>
      )}

      {currentView === "view" && (
        <ViewSurvey
          surveyData={selectedSurveyData}
          isVisitCompliance={isVisitCompliance}
          isGlobalProfile={isGlobalProfile}
          isApprover={isApprover}
          selectedCountry={getXTenantIDHeader()?.apiCountryCode}
          onBack={handleBack}
          onShowSignature={handleShowSignature}
          onRefreshData={() => fetchSurveyData(currentPage, itemsPerPage)}
          selectedCropStage={
            cropStages.find((stage) => stage.cropStageUid === selectedCropStage)
              ?.cropStageName || "Crop Stage"
          }
          year={selectedCropYear}
          selectedCropStageId={selectedCropStage}
        />
      )}

      {currentView === "signature" && (
        <SignaturePage
          data={selectedSurveyData}
          onBack={() => setCurrentView("view")}
          isVisitCompliance={isVisitCompliance}
        />
      )}
    </Layout>
  );
};

export default SurveyReopen;
